import React from 'react'
import { Link } from 'react-router-dom';
import {ip} from '../../config.js'
import 'react-toastify/dist/ReactToastify.css';

import { ToastContainer, toast } from 'react-toastify';


const SingleAlumniContainer = ({ cardInfo,setRelaod }) => {

    const notify = (message,type) => toast(message,{
        position: "top-center",
        type:type
    });
    

    function deletePhoto(eventId,photoId){
        console.log(eventId,photoId);
        fetch(ip+"/events/"+eventId+"/images/"+photoId,{
            method:'DELETE',
            headers: {'Authorization':'Basic '+ localStorage.getItem('sessionKey')}
        }).then((resp) => {
            if(resp.status !==200) throw new Error("Something went wrong");
            return resp.json();
        }).then((resp) => {
            console.log(resp);
            notify("Photo deleted successfully","success");
            setRelaod(new Date());
        }).catch((err) => {
            notify("Some error occurred: please contact the administrator","error")
        });
    }

    return (
        <>
            <ToastContainer/>

            {/* Information about the event */}
            <div className="card m-2">
                <div className="card-body">
                    <h5 className="card-title">{cardInfo.eventPurpose}</h5>
                    <p className="card-text"><b>Conducted By: {cardInfo.conductedBy}</b></p>

                    <p className="card-text">
                        {cardInfo.eventInDetail}
                    </p>
                    <p className="card-text"><small className="text-muted">Alumni Name: {cardInfo.alumniName + " ("} {cardInfo.alumniPassedOut + " Batch )"}</small></p>

                    <div className="d-flex justify-content-between align-items-center w-100">
                        <p className="card-text"><small className="text-muted">Event starts on : {
                            cardInfo.eventStartDate === null ?
                                "Not Mentioned" :
                                cardInfo.eventStartDate.split("T")[0]
                        }</small></p>

                    </div>
                    <p className="card-text"><small className="text-muted">Event ends on    : {
                        cardInfo.eventStartDate === null ?
                            "Not Mentioned" :
                            cardInfo.eventEndDate.split("T")[0]
                    }</small></p>
                </div>
            </div>

            {/* Photos Section */}
            <div className="card m-2">
                <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center w-100 ">
                        <h5 className="card-title">Photos</h5>
                        {
                            localStorage.getItem("sessionKey") !== null ?
                                <Link to={`/update/${cardInfo.id}`} className="btn btn-secondary m-3">Add Images</Link>
                                : ''
                        }
                    </div>

                    <div className="row">                        
                        {cardInfo.photos.map((photo, idx) => {
                            return (
                                <div key={idx} className="col-md-3 event-photo">
                                    <img src={photo.imageLocation} className="card-img" alt="..." />

                                    {
                                        localStorage.getItem('sessionKey')!==null ?
                                        <i className="fa fa-trash" onClick={()=> deletePhoto(cardInfo.id,photo.id)} aria-hidden="true"></i>
                                        : ''
                                    }

                                </div>
                            )
                        }
                        )}

                        {cardInfo.photos.length === 0 ? <p>No Photos Found</p> : ''}
                    </div>
                </div>
            </div>
        </>
    );
}

export default SingleAlumniContainer;